import React, { useEffect } from 'react';
import Breadcrumbs from '../../../widgets/breadcrumbs';
import SolicitationNotification from '../utils/solicitation-notification';
import solicitationNotifications from '../utils/solicitation-notification-helpers';
import ViewSolicitationDetail from './view-solicitation-detail';
import { useSetRecoilState } from 'recoil';
import { breadcrumbsPath } from '../utils/solicitation-helpers';

const ViewSolicitation = () => {
  const setSolicitationNotification = useSetRecoilState(
    solicitationNotifications,
  );

  useEffect(() => {
    // Clear notifications when the component is mounted
    setSolicitationNotification([]);
  }, []);

  return (
    <div className="grid-col">
      <Breadcrumbs current="View Solicitation" path={breadcrumbsPath} />
      <SolicitationNotification isModal={false} />
      <ViewSolicitationDetail />
    </div>
  );
};

export default ViewSolicitation;
